<div class="h-full w-full flex-grow !relative " leaflet [leafletOptions]="options"
    (leafletMapReady)="onMapReady($event)" [leafletBaseLayers]="tiles" (leafletClick)="onClick($event)"
    (leafletMouseOver)="refreshMap()">
    <div [leafletLayer]="marker" *ngFor="let marker of mapMarkers"></div>
    <button (click)="getPosition()"
        class="z-[500] rounded bg-primary text-white hover:text-primary hover:bg-white transition-colors duration-500 absolute bottom-1 left-1">
        <i class="fa fa-solid fa-location-crosshairs p-2 w-5 h-5"></i>
    </button>
</div>